import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopNav from "./TopNav";
import BottomNav from "./BottomNav";

import "../theme/design.css";
import "../theme/nav.css";
import "../theme/layout.css";

export default function AppLayout() {

  const location = useLocation();

  const hideChromeRoutes = [
    "/login",
    "/register",
    "/signup"
  ];

  const isClipsPage =
    location.pathname.startsWith("/clips");

  const isChatPage =
    location.pathname.startsWith("/chat/");

  const hideChrome =
    hideChromeRoutes.includes(location.pathname);

  const hideTopNav =
    hideChrome ||
    isClipsPage ||
    isChatPage;

  const hideBottomNav =
    hideChrome ||
    isChatPage;

  // Login/signup pages without shell
  if (hideChrome) {
    return <Outlet />;
  }

  return (
    <div className="app-shell">

      {/* TOP NAV */}
      {!hideTopNav && (
        <div className="app-topnav">
          <TopNav />
        </div>
      )}

      {/* MAIN */}
      <main
        className="app-main"
        style={{
          paddingTop: hideTopNav ? 0 : undefined,
        }}
      >
        <div className="app-page-wrap keyboard-safe">
          <Outlet />
        </div>
      </main>

      {/* BOTTOM NAV */}
      {!hideBottomNav && (
        <div className="app-bottomnav">
          <BottomNav />
        </div>
      )}

    </div>
  );
}